import React from "react";
import Image from "gatsby-plugin-sanity-image";

export interface ImageWithCaptionProps {
  asset: any;
  alt: string;
  caption: string;
  attribution: string;
}

const ImageWithCaption: React.FC<ImageWithCaptionProps> = ({
  asset,
  alt,
  caption,
  attribution,
}) => {
  return (
    <figure>
      {/* @ts-ignore */}
      <Image asset={asset} alt={alt} />
      {(caption || attribution) && (
        <figcaption className="text-center">
          {caption && <span>{caption}</span>}
          {attribution && <span> – {attribution}</span>}
        </figcaption>
      )}
    </figure>
  );
};

export default ImageWithCaption;